import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _89bcfc30 = () => interopDefault(import('../src/pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _b5d1fd4a = () => interopDefault(import('../src/pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _16ff4c01 = () => interopDefault(import('../src/pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _7e1d9b60 = () => interopDefault(import('../src/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _2c89238d = () => interopDefault(import('../src/pages/account/address/index.vue' /* webpackChunkName: "pages/account/address/index" */))
const _c210461e = () => interopDefault(import('../src/pages/account/createpassword.vue' /* webpackChunkName: "pages/account/createpassword" */))
const _f66db602 = () => interopDefault(import('../src/pages/account/login.vue' /* webpackChunkName: "pages/account/login" */))
const _3e108682 = () => interopDefault(import('../src/pages/account/orders/index.vue' /* webpackChunkName: "pages/account/orders/index" */))
const _29b95f7d = () => interopDefault(import('../src/pages/account/register.vue' /* webpackChunkName: "pages/account/register" */))
const _22cc5480 = () => interopDefault(import('../src/pages/account/requestpassword.vue' /* webpackChunkName: "pages/account/requestpassword" */))
const _2e6a9218 = () => interopDefault(import('../src/pages/account/reviews/index.vue' /* webpackChunkName: "pages/account/reviews/index" */))
const _5c017068 = () => interopDefault(import('../src/pages/account/user/index.vue' /* webpackChunkName: "pages/account/user/index" */))
const _0e7818e2 = () => interopDefault(import('../src/pages/account/wishlist/index.vue' /* webpackChunkName: "pages/account/wishlist/index" */))
const _10b74e1c = () => interopDefault(import('../src/pages/checkout/success.vue' /* webpackChunkName: "pages/checkout/success" */))
const _0aea7a1b = () => interopDefault(import('../src/pages/account/address/new.vue' /* webpackChunkName: "pages/account/address/new" */))
const _1196b596 = () => interopDefault(import('../src/pages/account/address/_id.vue' /* webpackChunkName: "pages/account/address/_id" */))
const _9c9b7d2c = () => interopDefault(import('../src/pages/account/orders/_id.vue' /* webpackChunkName: "pages/account/orders/_id" */))
const _1eb3a0b5 = () => interopDefault(import('../src/pages/account/return/_id.vue' /* webpackChunkName: "pages/account/return/_id" */))
const _80203f52 = () => interopDefault(import('../src/pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _89bcfc30,
    name: "account___fi"
  }, {
    path: "/cart",
    component: _b5d1fd4a,
    name: "cart___fi"
  }, {
    path: "/checkout",
    component: _16ff4c01,
    name: "checkout___fi"
  }, {
    path: "/search",
    component: _7e1d9b60,
    name: "search___fi"
  }, {
    path: "/account/address",
    component: _2c89238d,
    name: "account-address___fi"
  }, {
    path: "/account/createpassword",
    component: _c210461e,
    name: "account-createpassword___fi"
  }, {
    path: "/account/login",
    component: _f66db602,
    name: "account-login___fi"
  }, {
    path: "/account/orders",
    component: _3e108682,
    name: "account-orders___fi"
  }, {
    path: "/account/register",
    component: _29b95f7d,
    name: "account-register___fi"
  }, {
    path: "/account/requestpassword",
    component: _22cc5480,
    name: "account-requestpassword___fi"
  }, {
    path: "/account/reviews",
    component: _2e6a9218,
    name: "account-reviews___fi"
  }, {
    path: "/account/user",
    component: _5c017068,
    name: "account-user___fi"
  }, {
    path: "/account/wishlist",
    component: _0e7818e2,
    name: "account-wishlist___fi"
  }, {
    path: "/checkout/success",
    component: _10b74e1c,
    name: "checkout-success___fi"
  }, {
    path: "/account/address/new",
    component: _0aea7a1b,
    name: "account-address-new___fi"
  }, {
    path: "/account/address/:id",
    component: _1196b596,
    name: "account-address-id___fi"
  }, {
    path: "/account/orders/:id",
    component: _9c9b7d2c,
    name: "account-orders-id___fi"
  }, {
    path: "/account/return/:id?",
    component: _1eb3a0b5,
    name: "account-return-id___fi"
  }, {
    path: "/*",
    component: _80203f52,
    name: "all___fi"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
